import { render } from "./LocationDetail.vue?vue&type=template&id=060d3958&scoped=true"
import script from "./LocationDetail.vue?vue&type=script&lang=js"
export * from "./LocationDetail.vue?vue&type=script&lang=js"

import "./LocationDetail.vue?vue&type=style&index=0&id=060d3958&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060d3958"]])

export default __exports__